// Single source of truth for which regional variant of the site is being served.
// Uses the full URL like every other component (Titles, Footer, NavbarItem),
// so the ?local.navysealsmoving preview trick behaves consistently everywhere.
export function getSiteLocation() {
  const host = window.location.href;
  if (host.includes('local.navysealsmoving')) {
    return { type: 'local', regionName: 'Washington' };
  }
  if (host.includes('oregon.navysealsmoving')) {
    return { type: 'oregon', regionName: 'Oregon' };
  }
  if (host.includes('nynj.navysealsmoving')) {
    return { type: 'nynj', regionName: 'New York and New Jersey' };
  }
  if (host.includes('nc.navysealsmoving')) {
    return { type: 'nc', regionName: 'North Carolina' };
  }
  return { type: 'washington', regionName: 'Washington State' };
}
